import './index.less'
import {
  AccessLevelOptions,
  AccessLevelOptionsLabelMapper,
  IPermission,
  PermissionModules,
  PermissionModulesLabelMapper
} from '../../../constants'
import { updateRolePermission } from '../../../slice'
import { useIntl } from 'react-intl'
import React from 'react'
import { connect } from 'react-redux'
import { RadioGroup, Typography } from '@lightbeamai/design-system'

interface IProps {
  permissions?: IPermission[]
  isDetailsView?: boolean
  tableHeader?: string
  updateRolePermission: ({
    permissionName,
    currentAccessLevel
  }: {
    permissionName: PermissionModules
    currentAccessLevel: AccessLevelOptions
  }) => void
}

const CustomAccessGroupedTable = ({
  permissions,
  isDetailsView = true,
  tableHeader,
  updateRolePermission
}: IProps) => {
  const intl = useIntl()

  const handleAccessLevelChange = (e) => {
    permissions?.forEach(({ permissionName }) =>
      updateRolePermission({ permissionName, currentAccessLevel: e.target.value })
    )
  }

  if (!permissions) return <></>

  const firstPermission = permissions[0]

  return (
    <div className="grouped-permissions-container">
      <div className="row header-row">
        <Typography type={'strong'} variant={'baseMinus2'} className="row-item" as="div">
          {tableHeader}
        </Typography>
        <div className="row-item">
          <RadioGroup
            orientation="horizontal"
            disabled={isDetailsView}
            value={firstPermission?.currentAccessLevel}
            onChange={handleAccessLevelChange}
            className="action-radio-group"
            options={firstPermission?.accessOptions?.map((option) => ({
              children: (
                <Typography className="align-center">
                  {intl.formatMessage({ id: AccessLevelOptionsLabelMapper[option] })}
                </Typography>
              ),
              value: option
            }))}
          />
        </div>
      </div>
      {permissions?.map((perm) => {
        return (
          <div className="row item-row" key={perm.permissionName}>
            <Typography className="row-item">
              {intl.formatMessage({ id: PermissionModulesLabelMapper[perm.permissionName] })}
            </Typography>
            <Typography className="row-item">
              {perm.currentAccessLevel &&
                intl.formatMessage({ id: AccessLevelOptionsLabelMapper[perm.currentAccessLevel] })}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}

const mapDispatchToProps = {
  updateRolePermission
}

export default connect(null, mapDispatchToProps)(CustomAccessGroupedTable)
